/* eslint-disable global-require */

import angular from 'angular';

import PricingStickerFormController from './pricing-sticker-form.controller';

export default angular.module('autoboard.formPricingSticker', [])
  .directive('formPricingSticker', () => {
    'ngInject';

    return {
      controller: PricingStickerFormController,
      restrict: 'E',
      scope: {
        exit: '&',
        show: '=',
        vehicle: '=',
      },
      templateUrl: require('./pricing-sticker-form.template.html'),
    };
  })
  .name;
